<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('no')">
              Nomor
              <i
                :class="
                  currentSort === 'no'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('alphabet')">
              Alphabet
              <i
                :class="
                  currentSort === 'alphabet'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kbli')">
              Nama Kegiatan Usaha Utama
              <i
                :class="
                  currentSort === 'kbli'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('logo')">
              Logo
              <i
                :class="
                  currentSort === 'logo'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('last_modified_date')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'last_modified_date'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('last_modified_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'last_modified_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('status')">
              Status
              <i
                :class="
                  currentSort === 'status'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('catatan')">
              Catatan
              <i
                :class="
                  currentSort === 'catatan'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.alphabet }}</td>
            <td>{{ list.desc }}</td>
            <td>
              <a :href="list.logo" target="_blank">{{ list.logo }}</a>
            </td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/KBLI.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        alphabet: '',
        desc: '',
        logo: '',
        updatedAt: '',
        update_by: '',
        active: true,
        note: '-',
      },
      data: [
        {
          no: 1,
          alphabet: 'A',
          kbli: 'Pertanian, Kehutanan dan Perikanan',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 2,
          alphabet: 'B',
          kbli: 'Pertambangan dan Penggalian',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 3,
          alphabet: 'C',
          kbli: 'Industri Pengolahan',
          logo:
            'https://drive.google.com/uc?id=1CCTM5eGA49tiDAGwdztA4Xy5mXAlhGm3',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 4,
          alphabet: 'D',
          kbli: 'Pengadaan Listrik, Gas, Uap/Air Panas Dan Udara Dingin',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 5,
          alphabet: 'E',
          kbli:
            'Treatment Air, Treatment Air Limbah, Treatment dan Pemulihan Material Sampah, dan Aktivitas Remediasi',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 6,
          alphabet: 'F',
          kbli: 'Konstruksi',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 7,
          alphabet: 'G',
          kbli:
            'Perdagangan Besar Dan Eceran; Reparasi Dan Perawatan Mobil Dan Sepeda Motor',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 8,
          alphabet: 'H',
          kbli: 'Pengangkutan dan Pergudangan',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 9,
          alphabet: 'I',
          kbli: 'Penyediaan Akomodasi Dan Penyediaan Makan Minum',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 10,
          alphabet: 'J',
          kbli: 'Informasi Dan Komunikasi',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 11,
          alphabet: 'K',
          kbli: 'Aktivitas Keuangan dan Asuransi',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 12,
          alphabet: 'L',
          kbli: 'Real Estat',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 13,
          alphabet: 'M',
          kbli: 'Aktivitas Profesional, Ilmiah Dan Teknis',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 14,
          alphabet: 'N',
          kbli:
            'Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi, Ketenagakerjaan, Agen Perjalanan dan Penunjang Usaha Lainnya',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 15,
          alphabet: 'O',
          kbli:
            'Administrasi Pemerintahan, Pertahanan Dan Jaminan Sosial Wajib',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 16,
          alphabet: 'P',
          kbli: 'Pendidikan',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Active',
          catatan: '-',
        },
        {
          no: 17,
          alphabet: 'Q',
          kbli: 'Teknologi',
          logo: 'http://192.168.200.183:8081/img/1.8f213625.png',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'System',
          status: 'Inactive',
          catatan: 'test',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        alphabet: data.alphabet,
        desc: data.desc,
        logo: data.logo,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kbliData() {
      const result = this.$store.state.mdDatabaseStore.kbliData
      return result
    },
    sortedData() {
      return this.kbliData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
